"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[2236],{

/***/ 41124:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SkipContent_SkipContent)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/helpers/getters/getFocusableChildren.ts
var getFocusableChildren = __webpack_require__(3900);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(927);
;// CONCATENATED MODULE: ./src/components/ada/SkipContent/SkipContent.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SkipContent_module = ({"skipContent":"K9a1_9"});
;// CONCATENATED MODULE: ./src/components/ada/SkipContent/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Skip to main content"
    }
});

;// CONCATENATED MODULE: ./src/components/ada/SkipContent/SkipContent.tsx






const SkipContent = (param)=>{
    let { contentId } = param;
    const handleClick = (0,react.useCallback)((event)=>{
        event.preventDefault();
        const mainContentEl = document.getElementById(contentId);
        const focusableElements = (0,getFocusableChildren/* default */.Z)(mainContentEl);
        const firstFocusableEl = focusableElements[0];
        if (firstFocusableEl) {
            firstFocusableEl.focus();
        }
    }, [
        contentId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: SkipContent_module.skipContent,
        href: `#${contentId}`,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
            value: messages.title
        })
    });
};
/* harmony default export */ const SkipContent_SkipContent = (SkipContent);


/***/ })

}]);